module.exports = __webpack_public_path__ + "media/images/landkit/illustrations/illustration-1-dark-4f9a4f7b4527023b80f187d0e3fac646.png";